import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import Popup from "reactjs-popup";
import Dialog from "@mui/material/Dialog";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import AddPage from "../../../image/AddPage.svg";
import Pending from "../../../image/Pending.svg";
import Completed from "../../../image/Completed.svg";
import NewPage from "../../../NewPage/CreateForm";
import TimeLine from "../../../Timeline/TimeLine";
import "../../../NewPage/CreateForm.css";
import Claim from "../../../Claim/Claim";
import CreateForm from "../../../NewPage/CreateForm";
import Product from "../../../image/Product.svg";
import Collection from "../../../image/Collections.svg";
import LastCollection from "../../../image/LastCollection.svg";
import "./History.css";
import Viewstatus from "../../../ViewStatus/Viewstatus";
import "reactjs-popup/dist/index.css";
import { convertLength } from "@mui/material/styles/cssUtils";
import Viewsubmission from "../../Viewsubmission/Viewsubmission";
import Tempfile from "./Tempfile";

const History = (props) => {
  const [status, setstatus] = useState("empty");
  const [date, setdate] = useState("empty");
  const [myarr, setmyarr] = useState([]);
  const [secarr, setsecarr] = useState([]);
  const [bncolorandwork, setbncolorandwork] = useState(true);
  const [color, setcolor] = useState("");
  const [showTimeline, setshowTimeline] = useState(false);
  const [lastmodified, setlastmodified] = useState(undefined);
  const [open, setopen] = useState(false);
  const [opensecond, setopensecond] = useState(false);

  const verifiedRef = useRef(false);
  const params = useParams();

  useEffect(() => {
    const myfunc = async () => {
      const response = await fetch(
        `http://localhost:5000/application/formid/${params._id}`,
        {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          // credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            //   'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,

            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          // body: JSON.stringify(data) // body data type must match "Content-Type" header
        }
      );

      const data = await response.json();

      setmyarr(data.applications);

      callHistory(data.applications[0].id);

      setlastmodified(data.applications[0].modified);
    };
    myfunc();
  }, []);

  let completedcount = 0;
  let Rejectedcount = 0;

  for (let i = 0; i < myarr.length; i++) {
    if (myarr[i].applicationStatus == "Completed") {
      console.log(myarr[i])
      completedcount++;
    }
  }

  for (let i = 0; i < myarr.length; i++) {
    if (myarr[i].applicationStatus == "Rejected") {
      Rejectedcount++;
    }
  }

  let totalcount = myarr.length;

  // let modified=myarr

  let pending = totalcount - completedcount - Rejectedcount;

  function formatDate(string) {
    var options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }

  const callHistory = async (id) => {
    const response = await fetch(
      `http://localhost:5000/application/${id}/history`,
      {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          //   'Content-Type': 'application/json',
          Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,

          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
      }
    );
    const data = await response.json();

    setsecarr(data.applications);
  };

  const getprocinsidnset = async (applicationid) => {
    const response = await fetch(
      `http://localhost:5000/application/${applicationid}`,
      {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          //   'Content-Type': 'application/json',
          Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,

          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
      }
    );
    const data = await response.json();

    localStorage.setItem("processInstanceId", data.processInstanceId);
  };

  return (
    <>
      <div className="card Card-Row Box">
        <div className="Card-Row-Boxes">
          <div className="Card-Box Card-Box-row">
            <img src={Product} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Product</span>
              <h6 className="Card-Box-Head2">WEF</h6>
            </div>
          </div>
          <div className="Card-Box Card-Box-row">
            <img src={Collection} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Collection</span>
              <h6 className="Card-Box-Head2">Weekly</h6>
            </div>
          </div>
          <div className="Card-Box Card-Box-row">
            <img
              src={LastCollection}
              className="ProductImage"
              alt="ProductImage"
            />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Last Collected</span>
              <h6 className="Card-Box-Head2">
                {lastmodified != null ? formatDate(lastmodified) : "Never"}
              </h6>
            </div>
          </div>
          <div className="Card-Box Card-Box-row">
            <img src={Pending} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Pending</span>
              <h6 className="Card-Box-Head2">
                {pending != null ? pending : "Never"}
              </h6>
            </div>
          </div>
          <div className="Card-Box Card-Box-row">
            <img src={Completed} className="ProductImage" alt="ProductImage" />
            <div className="card-Box-headings">
              <span className="Card-Box-Head">Completed</span>
              <h6 className="Card-Box-Head2">
                {completedcount != null ? completedcount : "Never"}
              </h6>
            </div>
          </div>
        </div>
        <span className="Card_Data_Title">{props.data}</span>
      </div>
      <div className="HistoryContainer">
        <div className="navbar nav AddPage mt-3">
          <div>
            {!!JSON.parse(localStorage.getItem("UserDetails")).groups.find(
              (val) => val === "/formsflow/formsflow-client"
            ) && (
              <div>
                <Button onClick={() => setopen(true)} className="NewPageButton">
                  {" "}
                  <img src={AddPage} alt="Add Page Icon" />
                </Button>

                <Dialog open={open} onClose={() => setopen(false)}>
                  <div className="PopUpTopSection">
                    <h6 className="PopupTitleHeading">Title : </h6>
                    <button
                      className="CancelButtton"
                      onClick={() => setopen(false)}
                    >
                      X
                    </button>
                  </div>
                  <DialogContent>
                    <DialogContentText>
                      <CreateForm
                        formId={params._id}
                        bigArray={props.bigArray}
                      />
                    </DialogContentText>
                  </DialogContent>
                </Dialog>
                <span className="AddNewRecord">Add New Record</span>
              </div>
            )}
          </div>
          {(!!JSON.parse(localStorage.getItem("UserDetails")).groups.find(
            (val) => val === "/formsflow/formsflow-reviewer/approver"
          ) ||
            !!JSON.parse(localStorage.getItem("UserDetails")).groups.find(
              (val) => val === "/formsflow/formsflow-reviewer/clerk"
            )) && (
            <div>
              <Button
                disabled={bncolorandwork}
                className={bncolorandwork ? "ClaimNow invisible" : "ClaimNow"}
                onClick={() => setopen(true)}
              >
                {" "}
                <span className="ClaimText">Review</span>
              </Button>
              <Dialog open={open} onClose={() => setopen(false)}>
                <DialogContent>
                  <DialogContentText>
                    <Claim />
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </div>
          )}
        </div>
        <div className="MainTable">
          <div className="col-md-12" style={{ height: "100%" }}>
            <div className="row" style={{ height: "100%" }}>
              <div className="col-md-6 ScrollableStatus">
                <table className="Lefttable">
                  <thead className="TableHeading">
                    <tr>
                      <th className="StatusRow">Status</th>
                      <th className="dateRow">Date</th>
                    </tr>
                  </thead>
                  <tbody className="HistoryBodyList">
                    {myarr.map((data, i, arr) => {
                      let k;

                      const callkrdiya = async (yo, mi) => {
                        const response = await fetch(
                          `http://localhost:3001/form/${yo}/submission/${mi}`,
                          {
                            method: "GET", // *GET, POST, PUT, DELETE, etc.
                            mode: "cors", // no-cors, *cors, same-origin
                            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                            // credentials: 'same-origin', // include, *same-origin, omit
                            headers: {
                              //   'Content-Type': 'application/json',

                              "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
                              // 'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            redirect: "follow", // manual, *follow, error
                            referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                            // body: JSON.stringify(data) // body data type must match "Content-Type" header
                          }
                        );

                        const data = await response.json();
                      };

                      return (
                        <>
                          <tr
                            key={i}
                            className="TableBody"
                            id="TableRow"
                            onClick={(e) => {
                              setshowTimeline(true);
                              callHistory(data.id);
                              getprocinsidnset(data.id);

                              // e.currentTarget.style.boxShadow = '2px 0px 4px 4px rgba(192, 163, 119, 0.25)';
                              localStorage.setItem("formid", data.formId);
                              localStorage.setItem(
                                "submissionid",
                                data.submissionId
                              );

                              if (
                                localStorage.getItem("formid") &&
                                localStorage.getItem("submissionid")
                              ) {
                                setbncolorandwork(false);
                              }

                              //   if(data.applicationStatus=="Resubmit")
                              //   {
                              //     setbncolorandwork(true);
                              //   }

                              if (data.applicationStatus == "Approved") {
                                setbncolorandwork(true);
                              }

                              if (data.applicationStatus == "Resubmit") {
                                setbncolorandwork(true);
                              }

                              if (data.applicationStatus == "Rejected") {
                                setbncolorandwork(true);
                              }

                              if (
                                data.applicationStatus == "New" &&
                                !!JSON.parse(
                                  localStorage.getItem("UserDetails")
                                ).groups.find(
                                  (val) =>
                                    val ===
                                    "/formsflow/formsflow-reviewer/approver"
                                )
                              ) {
                                setbncolorandwork(true);
                              }

                              if (
                                data.applicationStatus == "Reviewed" &&
                                !!JSON.parse(
                                  localStorage.getItem("UserDetails")
                                ).groups.find(
                                  (val) =>
                                    val ===
                                    "/formsflow/formsflow-reviewer/clerk"
                                )
                              ) {
                                setbncolorandwork(true);
                              }

                              if (
                                data.applicationStatus == "Resubmitted" &&
                                !!JSON.parse(
                                  localStorage.getItem("UserDetails")
                                ).groups.find(
                                  (val) =>
                                    val ===
                                    "/formsflow/formsflow-reviewer/clerk"
                                )
                              ) {
                                setbncolorandwork(true);
                              }

                              k = i;
                              setcolor("p-3 mb-2 bg-primary text-white");
                            }}
                          >
                            <td className="StatusbarRows">
                              {data.applicationStatus}
                            </td>
                            <td className="DatebarRows">
                              {formatDate(data.modified)}
                            </td>
                            <td className="DatebarRows">
                              <Tempfile data={data} />
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {showTimeline ? (
                <div className="col-md-6 HistoryScrollbar">
                  <div className="HistoryData">
                    <h6 className="HistoryTitle">History</h6>
                    <div
                      style={{ marginTop: "-2.3rem" }}
                      className="TimelineWidth"
                    >
                      <TimeLine myarray={secarr} />
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    marginLeft: "5rem",
                    fontFamily: "Poppins,sans-serif",
                    fontStyle: "normal",
                    fontWeight: "var(--Light)",
                    fontSize: "var(--TableTitle)",
                    lineHeight: "2rem",
                    color: "var(--TextColorBlack)",
                  }}
                >
                  Click on any status bar to show history
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default History;
